'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('./constants');

/**
 * Removes created 3DSv2 challenge iframe
 * @returns {void}
 */
var remove3DSv2ChallengeIframe = function remove3DSv2ChallengeIframe() {
  var challengeIframe = document.getElementById(_constants.CHALLENGE_IFRAME_3DSV2);

  if (challengeIframe !== null) {
    challengeIframe.parentNode.removeChild(challengeIframe);
  }
};

exports.default = remove3DSv2ChallengeIframe;